const tutorialData = [
  {
    header: 'Recommendations',
    text: 'Here are your first 50 college coach matches. As you contact them they will be replaced by new matches. Contact every coach you see to maximize your recruitment. \n',
    image: 'recommendations.png',
  },
  {
    header: 'Filter',
    text: 'Try Filter to view and contact coaches from other divisions. Remember, the more exposure you get, the better your chances are. You never know the perfect fit for you until you explore all of your options. Contact every coach you have matched for your best recruitment outcome. \n',
    image: 'filter.png',
  },
  {
    header: 'Load More',
    text: 'Click load more button to view more colleges.\n',
    image: 'loadmore.png',
  },
];

export default tutorialData;



// WEBPACK FOOTER //
// ./src/components/DashboardView/Tutorial/TutorialData.js